import React from 'react';
import { Button, openReferralModal } from '@/components';
import { useUserXP } from '@/views/XP/hooks/xp';
import { Trans, useTranslation } from 'react-i18next';
import cx from 'clsx';
import { useTheme } from '@/hooks';

import styles from './index.module.scss';

export const RefererXP = ({ articleId }: { articleId: number }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const { data } = useUserXP();
  const handleClick = () => {
    openReferralModal({ link: `${window.location.origin}/stream/${articleId}`, isQuest: true });
  };
  if (!data) {
    return null;
  }
  return (
    <div className={cx(styles.container, isDark && styles.dark)}>
      <div className={cx(styles.title, isDark && styles.dark)}>
        <Trans i18nKey="RefererXP.title" values={{ amount: data ? data?.referral_xp : '-' }}>
          You have earned <span className={styles.bold}>{data ? data?.referral_xp : '-'} XP</span>{' '}
          through <span className={styles.bold}>referrals</span>
        </Trans>
      </div>
      <Button type="primary" className={styles.btn} onClick={handleClick}>
        {t('RefererXP.1l27745')}
      </Button>
    </div>
  );
};
